// extracted by mini-css-extract-plugin
export default {"wrapper":"Footer_wrapper__bD5gD","socials":"Footer_socials__qPenP"};